import React from 'react'

import { required } from '@cinch/oxd-utils/validators/src'
import { Field } from 'react-final-form'

import * as styles from './postcode-field.module.css'
import { TextFieldWrapper } from '../../../../final-form-wrappers/src'

const PostcodeForm: React.FC<any> = () => (
  <div className={styles.form}>
    <Field
      classNames={{ container: styles.input }}
      name="postcode"
      type="text"
      fullWidth={false}
      component={TextFieldWrapper}
      oxford={true}
      validate={required}
      label={'Postcode'}
      autoComplete="postal-code"
      placeholder={'e.g. SW15 1EQ'}
    />
  </div>
)

export default PostcodeForm
